export const LANDING_PAGE_URL = 'https://herzbergimmobilien.de'
export const MOBILE = 'mobile'
export const DESKTOP = 'desktop'
